import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WindowBase"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 1.5H12.75V3.75H11.25V1.5ZM18.75 9.75H21V11.25H18.75V9.75ZM11.25 17.25H12.75V19.5H11.25V17.25ZM3 9.75H5.25V11.25H3V9.75ZM5.08115 4.64101L6.1424 3.57976L7.7339 5.17126L6.6734 6.23176L5.08115 4.64101ZM16.2719 5.17498L17.8619 3.58348L18.9232 4.64473L17.3324 6.23473L16.2719 5.17498ZM16.2681 15.816L17.3294 14.7555L18.9194 16.347L17.8596 17.4075L16.2681 15.816ZM5.08342 16.3598L6.67492 14.7675L7.73542 15.828L6.14467 17.4195L5.08342 16.3598ZM3 21H21V22.5H3V21ZM12 15C14.4853 15 16.5 12.9853 16.5 10.5C16.5 8.01472 14.4853 6 12 6C9.51472 6 7.5 8.01472 7.5 10.5C7.5 12.9853 9.51472 15 12 15ZM12 7.5V13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WindowBase.vue"]]);
